import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { formatSegmentationPayload, formatSegmentationResponse, validateSegmentationPayload } from "../../utils/segmentation-utils";
import { hasValidationErrors } from "../../../utils/validation-utils";

export function useSegmentationUpdate() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    const validateSegmentation = values => {
        const errors = validateSegmentationPayload(values);

        setValidationErrors(errors);

        return errors;
    };

    async function updateSegmentation(segmentationId, payloadData) {
        const errors = validateSegmentationPayload(payloadData);

        if (hasValidationErrors(errors)) {
            setValidationErrors(errors);
            setError(null);

            return {
                ok: false,
                reason: "validation",
                validationErrors: errors
            };
        }

        try {
            setLoading(true);
            setError(null);
            setValidationErrors({});

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const body = formatSegmentationPayload(payloadData);

            const requestOptions = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                },
                body: JSON.stringify(body)
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível editar a segmentação."
                );
            }

            const data = await response.json();

            const segmentationData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedSegmentation = formatSegmentationResponse(segmentationData);

            return {
                ok: true,
                segmentation: formattedSegmentation
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        validationErrors,
        validateSegmentation,
        updateSegmentation
    };
}